module.exports = __webpack_public_path__ + "static/media/done-orange.d1cceef4.svg";